module.exports = __webpack_public_path__ + "static/img/nanjing.aa3a1d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/nanjing.png
// module id = H2hW
// module chunks = 1